import { sva } from '@onbeam/business-styled-system/css';

export const accordion = sva({
  className: 'accordion',
  slots: ['root', 'trigger', 'content', 'contentInner', 'icon'],
  base: {
    root: {
      display: 'flex',
      flexDirection: 'column',
      borderBottom: '1px solid',
      borderColor: 'opacity.md',
      py: '6',
    },
    trigger: {
      w: 'full',
      display: 'flex',
      justifyContent: 'space-between',
      gap: '4',
      textAlign: 'start',
      transition: 'colors',
      cursor: 'pointer',
      textStyle: 'body-lg',

      _supportsHover: {
        _hover: {
          color: 'mono.tertiary',
        },
      },
      _focusVisible: {
        color: 'mono.tertiary',
      },
      _open: {
        '& [data-open-icon]': {
          display: 'flex',
        },
      },
      _closed: {
        '& [data-closed-icon]': {
          display: 'flex',
        },
      },
    },
    icon: {
      display: 'none',
    },
    content: {
      overflow: 'hidden',
      animationDuration: 'normal',
      animationTimingFunction: 'ease-out',

      _open: {
        animationName: 'radixContentSlideDown',
      },
      _closed: {
        animationName: 'radixContentSlideUp',
      },
    },
    contentInner: {
      pt: '2.5',
      textStyle: 'body-md',
      color: 'mono.tertiary',
    },
  },
});
